import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { setMaterialSelection } from '../../store/actions';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));

const SelectedChip = (props) => {
  const classes = useStyles();

  const handleDelete = (name) => () => {

    const selected = props.materials[props.defect] || []
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected,name];
    } else {
      // Remove
      newSelected = [...selected.slice(0,selectedIndex)
                    ,...selected.slice(selectedIndex+1)
      ]
    }
    props.setMaterialSelection(props.defect, newSelected);
  };

  return (
    <div className={classes.root}>
      {(props.materials[props.defects.currentDefect] || []).map((elm,index) =>      
        <Chip key={index} label={elm} onDelete={handleDelete(elm)} color="secondary" />
      )}
    </div>
  );
}



const mapStateToProps = (state) => ({
    materials: state.materialReducer,
    defects: state.defectReducer
});

const mapDispatchToProps = {
  setMaterialSelection: setMaterialSelection,
    
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedChip)
